import {
	type FundDatum,
	type FundExplorerPanelConfig,
	FundExplorerPanelConfigSchema,
} from "@/FundExplorer/types";
import type { Tab } from "@/components/Tabs/types";
import { parseHTMLFragment } from "@/lib";
import { SRP } from "hsl-core/providers";

export default function useFundPanelTabs<K extends string>(
	fund: FundDatum,
	configId?: number,
): [Tab<K>[], FundExplorerPanelConfig | null] {
	const { data } = SRP.usePart(!!configId, {
		id: configId,
		fund_id: fund.id as number,
	});

	const parsedConfig = data
		? FundExplorerPanelConfigSchema.safeParse(parseHTMLFragment(data as string))
		: null;
	if (!parsedConfig?.success) {
		return [[], null];
	}
	const tabs = Object.entries(parsedConfig.data).reduce(
		(acc, [key, _parsedConfig]) => {
			if (Object.keys(_parsedConfig).length === 0) {
				return acc;
			}
			acc.push({
				label: "label" in _parsedConfig ? _parsedConfig.label : key,
				key: key as K,
			});
			return acc;
		},
		[] as Tab<K>[],
	);
	return [tabs, parsedConfig.data];
}
